import React from 'react';
import { DynamicTooltip } from '@gpstrackit/gtc-react-controls';
import { useIntl } from 'react-intl';
import './styles.scss';

const HistoryTooltip = ({ children, historyData }) => {
    const { messages } = useIntl();

    const getTranslatedMetric = (metricName) => {
        const metricKey = metricName.replace(/\s+/g, '').toLowerCase();
        const translationKey = `driver_performance_historyTooltip_${metricKey}`;
        return messages[translationKey] || metricName;
    };

    const renderTooltipContent = () => {
        let parsedData = historyData;

        // Parse string to JSON if needed
        if (typeof historyData === 'string') {
            try {
                parsedData = JSON.parse(historyData);
            } catch (error) {
                return <div>{messages['driver_performance_historyTooltip_noHistory']}</div>;
            }
        }

        if (!parsedData?.history || parsedData.history.length === 0) {
            return <div>{messages['driver_performance_historyTooltip_noHistory']}</div>;
        }

        return (
            <div className="history-tooltip__container">
                {parsedData.history.map((item, index) => (
                    <div key={index} className="history-tooltip__item">
                        <div className="history-tooltip__header">
                            <span className="history-tooltip__status">
                                {messages['driver_performance_historyTooltip_status']}: {item.resultStatus === 'evaluateJudgement' ? messages['driver_performance_historyTooltip_statusEvaluation'] : messages['driver_performance_historyTooltip_statusEscalation']}
                            </span>
                            <span className="history-tooltip__date">
                                {messages['driver_performance_historyTooltip_effectiveDate']}: {new Date(item.endEvaluationDate).toLocaleDateString()}
                            </span>
                        </div>
                        <table className="history-tooltip__table">
                            <thead>
                                <tr>
                                    <th>{messages['driver_performance_historyTooltip_metric']}</th>
                                    <th>{messages['driver_performance_historyTooltip_measure']}</th>
                                    <th>{messages['driver_performance_historyTooltip_target']}</th>
                                    <th>{messages['driver_performance_historyTooltip_byDistance']}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {item.metrics.map((metric, metricIndex) => (
                                    <tr key={metricIndex}>
                                        <td>{getTranslatedMetric(metric.metric)}</td>
                                        <td>
                                            {typeof metric.measure === 'string' ? parseFloat(metric.measure).toFixed(2) : Number(metric.measure).toFixed(2)}
                                        </td>
                                        <td>
                                            {metric.metric === 'Total Distance' ? '' : metric.target}
                                        </td>
                                        <td>
                                            {metric.metric === 'Total Distance' ? metric.target : ''}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <DynamicTooltip
            trigger={children}
            openOn="click"
            size="medium"
            position="bottom"
        >
            {renderTooltipContent()}
        </DynamicTooltip>
    );
};

export default HistoryTooltip;
